/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Minimal representation of a quote that would be affected by entity modifications
 * @export
 * @interface AffectedQuoteDto
 */
export interface AffectedQuoteDto {
    /**
     * Unique identifier of the risk/simulation
     * @type {string}
     * @memberof AffectedQuoteDto
     */
    riskId?: string;
    /**
     * Unique identifier of the quote
     * @type {string}
     * @memberof AffectedQuoteDto
     */
    quoteId?: string;
    /**
     * Human-readable quote identifier
     * @type {string}
     * @memberof AffectedQuoteDto
     */
    quoteIdentifier?: string;
    /**
     * Name of the main subscriber
     * @type {string}
     * @memberof AffectedQuoteDto
     */
    subscriberName?: string;
    /**
     * Branch code (EMP, CHO, GLI, CBNO)
     * @type {string}
     * @memberof AffectedQuoteDto
     */
    branchCode?: string;
    /**
     * Label of the quote status
     * @type {string}
     * @memberof AffectedQuoteDto
     */
    statusLabel?: string;
    /**
     * Unique identifier of the borrower project (only for EMP branch)
     * @type {string}
     * @memberof AffectedQuoteDto
     */
    borrowerProjectId?: string | null;
}

/**
 * Check if a given object implements the AffectedQuoteDto interface.
 */
export function instanceOfAffectedQuoteDto(value: object): value is AffectedQuoteDto {
    return true;
}

export function AffectedQuoteDtoFromJSON(json: any): AffectedQuoteDto {
    return AffectedQuoteDtoFromJSONTyped(json, false);
}

export function AffectedQuoteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffectedQuoteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'quoteId': json['quoteId'] == null ? undefined : json['quoteId'],
        'quoteIdentifier': json['quoteIdentifier'] == null ? undefined : json['quoteIdentifier'],
        'subscriberName': json['subscriberName'] == null ? undefined : json['subscriberName'],
        'branchCode': json['branchCode'] == null ? undefined : json['branchCode'],
        'statusLabel': json['statusLabel'] == null ? undefined : json['statusLabel'],
        'borrowerProjectId': json['borrowerProjectId'] == null ? undefined : json['borrowerProjectId'],
    };
}

export function AffectedQuoteDtoToJSON(json: any): AffectedQuoteDto {
    return AffectedQuoteDtoToJSONTyped(json, false);
}

export function AffectedQuoteDtoToJSONTyped(value?: AffectedQuoteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskId': value['riskId'],
        'quoteId': value['quoteId'],
        'quoteIdentifier': value['quoteIdentifier'],
        'subscriberName': value['subscriberName'],
        'branchCode': value['branchCode'],
        'statusLabel': value['statusLabel'],
        'borrowerProjectId': value['borrowerProjectId'],
    };
}

